import React, { useEffect, useState } from 'react';
import '../../../styles/Admin/admin_editannouncement.css';
import moment from 'moment';
import { BiPen, BiCheckCircle, BiCheckDouble } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import { displaySnackbar, YesNoSelector } from '../../../utilities';
import { BASE_URL } from '../../../settings';

export default function Admin_EditEvent({ event, fetchEvents, fetchEventById }) {
    const [fetched_event, setFetchedEvent] = useState(event);
    const [isUpdating, setIsUpdating] = useState(false);
    const [isHovering, setIsHovering] = useState(false);
    const [name, setName] = useState();
    const [color, setColor] = useState();
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [subscribers, setSubscribers] = useState(0);
    const [details, setDetails] = useState();
    const [priority, setPriority] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        // 👇️ apply a class to main top nav bar to hide it
        let mainNavBar = document.querySelector('._3drDv.MainNavBar');
        if (mainNavBar) mainNavBar.style.display = 'none';

        window.scrollTo({ top: 0, behavior: 'smooth' });

        let pathname = location.pathname.split('/');
        let id = pathname[pathname.length - 1];

        fetch(`${BASE_URL}/events/read`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id }),
        })
            .then(async (result) => {
                let response = await result.json();
                let the_event = response?.event;
                setFetchedEvent(the_event);
                if (the_event) {
                    setName(the_event?.name);
                    setColor(the_event?.color);
                    setStartDate(the_event?.startDate);
                    setEndDate(the_event?.endDate);
                    setSubscribers(the_event?.subscribers);
                    setDetails(the_event?.details);
                    setPriority(the_event?.priority);
                }
            })
            .catch((error) => {
                console.log(error?.message, '\n', error);
            });
    }, []);

    // 👇️ handler to update an event.
    const updateEvent = () => {
        setIsUpdating(false);

        try {
            fetch(`${BASE_URL}/events/update`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: fetched_event?.uuid,
                    name,
                    color,
                    startDate,
                    endDate,
                    subscribers,
                    details,
                    priority,
                }),
            })
                .then(async (result) => {
                    let response = await result?.json();
                    if (response?.msg === null) {
                        displaySnackbar(response?.errorMsg, true, 'Ok', () => {});
                    } else {
                        console.log(response);
                        displaySnackbar(response?.msg, false, 'Ok', () => {});
                        setTimeout(() => {
                            fetchEvents();
                            fetchEventById(fetched_event?.uuid);
                        }, 1000);
                    }
                })
                .catch((error) => {
                    if (error?.message == 'Failed to fetch') {
                        displaySnackbar('Could not reach the servers', true, 'Ok', () => {});
                    } else {
                        displaySnackbar('Some error occured!', true, 'Ok', () => {});
                        console.log('the error:', error);
                    }
                });
        } catch (error) {
            console.log(error?.message, '\n', error);
        }
    };

    return (
        <div className='alumni-detail'>
            {/* go back button */}
            <button onClick={() => fetchEventById(fetched_event?.uuid)}>👈️ Go Back</button>

            {/* header bar */}
            <div className='alumni-detail-header-bar'>
                <div className='left'>
                    <h1>Edit Event</h1>
                </div>
                <div className='right'></div>
            </div>

            {/* alumni content */}
            <div className='alumni-detail-main-content'>
                <div className='details'>
                    <span className='details-sub-header'>Event Information</span>

                    <div className='details-content-item'>
                        <span className='title'>Actions</span>
                        <button style={{ backgroundColor: 'green' }} onClick={updateEvent}>
                            Update
                        </button>
                    </div>

                    <div
                        className='details-content-item'
                        style={{ cursor: 'pointer' }}
                        onMouseEnter={() => setIsHovering(true)}
                        onMouseLeave={() => setIsHovering(false)}
                    >
                        <span className='title'>
                            Details{' '}
                            {isHovering && !isUpdating && (
                                <BiPen
                                    onClick={() => setIsUpdating(!isUpdating)}
                                    size={25}
                                    className='edit-pen'
                                />
                            )}
                            {isUpdating && (
                                <BiCheckDouble
                                    onClick={() => setIsUpdating(!isUpdating)}
                                    size={35}
                                    color='green'
                                    className='edit-pen'
                                />
                            )}
                        </span>
                        {isUpdating ? (
                            <textarea
                                type='text'
                                name='details'
                                placeholder='Details'
                                rows={10}
                                value={details || ''}
                                onChange={(e) => setDetails(e.target.value)}
                            />
                        ) : details?.length > 0 ? (
                            <p className='text about'>{details}</p>
                        ) : (
                            <p className='empty-text'>...</p>
                        )}
                    </div>

                    <div className='details-content-items'>
                        <div className='details-content-item'>
                            <span className='title'>id</span>
                            {fetched_event?.id ? (
                                <p className='text'>{fetched_event?.id}</p>
                            ) : (
                                <p className='empty-text'>...</p>
                            )}
                        </div>

                        <div className='details-content-item'>
                            <span className='title'>user id (uuid)</span>
                            {fetched_event?.uuid?.length > 0 ? (
                                <p className='text'>{fetched_event?.uuid}</p>
                            ) : (
                                <p className='empty-text'>...</p>
                            )}
                        </div>

                        <div
                            className='details-content-item'
                            style={{ cursor: 'pointer' }}
                            onMouseEnter={() => setIsHovering(true)}
                            onMouseLeave={() => setIsHovering(false)}
                        >
                            <span className='title'>
                                Name
                                {isHovering && !isUpdating && (
                                    <BiPen
                                        onClick={() => setIsUpdating(!isUpdating)}
                                        size={25}
                                        className='edit-pen'
                                    />
                                )}
                                {isUpdating && (
                                    <BiCheckDouble
                                        onClick={() => setIsUpdating(!isUpdating)}
                                        size={35}
                                        color='green'
                                        className='edit-pen'
                                    />
                                )}
                            </span>
                            {isUpdating ? (
                                <input
                                    placeholder='name...'
                                    type='text'
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            ) : name?.length > 0 ? (
                                <p className='text'>{name}</p>
                            ) : (
                                <p className='empty-text'>...</p>
                            )}
                        </div>

                        <div
                            className='details-content-item'
                            style={{ cursor: 'pointer' }}
                            onMouseEnter={() => setIsHovering(true)}
                            onMouseLeave={() => setIsHovering(false)}
                        >
                            <span className='title'>
                                Color
                                {isHovering && !isUpdating && (
                                    <BiPen
                                        onClick={() => setIsUpdating(!isUpdating)}
                                        size={25}
                                        className='edit-pen'
                                    />
                                )}
                                {isUpdating && (
                                    <BiCheckDouble
                                        onClick={() => setIsUpdating(!isUpdating)}
                                        size={35}
                                        color='green'
                                        className='edit-pen'
                                    />
                                )}
                            </span>
                            {isUpdating ? (
                                <>
                                    <label htmlFor='color'>Event Color</label>
                                    <input
                                        type='color'
                                        name='color'
                                        id='color'
                                        placeholder='Color...'
                                        value={color}
                                        onChange={(e) => setColor(e.target.value)}
                                    />
                                </>
                            ) : color?.length > 0 ? (
                                <p
                                    className='text'
                                    style={{
                                        backgroundColor: fetched_event?.color,
                                        color: '#eee',
                                        borderRadius: '.5rem',
                                        padding: '.5rem',
                                    }}
                                >
                                    {color}
                                </p>
                            ) : (
                                <p className='empty-text'>...</p>
                            )}
                        </div>

                        <div
                            className='details-content-item'
                            style={{ cursor: 'pointer' }}
                            onMouseEnter={() => setIsHovering(true)}
                            onMouseLeave={() => setIsHovering(false)}
                        >
                            <span className='title'>
                                Start Date
                                {isHovering && !isUpdating && (
                                    <BiPen
                                        onClick={() => setIsUpdating(!isUpdating)}
                                        size={25}
                                        className='edit-pen'
                                    />
                                )}
                                {isUpdating && (
                                    <BiCheckDouble
                                        onClick={() => setIsUpdating(!isUpdating)}
                                        size={35}
                                        color='green'
                                        className='edit-pen'
                                    />
                                )}
                            </span>
                            {isUpdating ? (
                                <input
                                    type='date'
                                    name='startDate'
                                    id='startDate'
                                    placeholder='start date'
                                    value={startDate}
                                    title='the date that this event starts.'
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                            ) : fetched_event?.startDate?.length > 0 ? (
                                <p className='text'>
                                    {moment(new Date(fetched_event?.startDate)).calendar()}
                                </p>
                            ) : (
                                (<p className='empty-text'>...</p>)()
                            )}
                        </div>

                        <div
                            className='details-content-item'
                            style={{ cursor: 'pointer' }}
                            onMouseEnter={() => setIsHovering(true)}
                            onMouseLeave={() => setIsHovering(false)}
                        >
                            <span className='title'>
                                End Date
                                {isHovering && !isUpdating && (
                                    <BiPen
                                        onClick={() => setIsUpdating(!isUpdating)}
                                        size={25}
                                        className='edit-pen'
                                    />
                                )}
                                {isUpdating && (
                                    <BiCheckDouble
                                        onClick={() => setIsUpdating(!isUpdating)}
                                        size={35}
                                        color='green'
                                        className='edit-pen'
                                    />
                                )}
                            </span>
                            {isUpdating ? (
                                <input
                                    type='date'
                                    name='endDate'
                                    id='endDate'
                                    placeholder='end date'
                                    value={endDate}
                                    title='the date that this event ends.'
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                            ) : fetched_event?.endDate?.length > 0 ? (
                                <p className='text'>
                                    {moment(new Date(fetched_event?.endDate)).calendar()}
                                </p>
                            ) : (
                                (<p className='empty-text'>...</p>)()
                            )}
                        </div>

                        <div
                            className='details-content-item'
                            style={{ cursor: 'pointer' }}
                            onMouseEnter={() => setIsHovering(true)}
                            onMouseLeave={() => setIsHovering(false)}
                        >
                            <span className='title'>
                                priority
                                {isHovering && !isUpdating && (
                                    <BiPen
                                        onClick={() => setIsUpdating(!isUpdating)}
                                        size={25}
                                        className='edit-pen'
                                    />
                                )}
                                {isUpdating && (
                                    <BiCheckDouble
                                        onClick={() => setIsUpdating(!isUpdating)}
                                        size={35}
                                        color='green'
                                        className='edit-pen'
                                    />
                                )}
                            </span>
                            {isUpdating ? (
                                <select
                                    name='priority'
                                    onChange={(e) => setPriority(e?.target?.value)}
                                >
                                    <option selected disabled>
                                        Priority
                                    </option>
                                    <option value={'high'}>high</option>
                                    <option value={'low'}>low</option>
                                </select>
                            ) : fetched_event?.priority?.length > 0 ? (
                                <p className='text'>{priority}</p>
                            ) : (
                                <p className='empty-text'>...</p>
                            )}
                        </div>

                        <div className='details-content-item'>
                            <span className='title'>Posted on</span>
                            {fetched_event?.createdAt?.length > 0 ? (
                                <p className='text'>
                                    {moment(new Date(fetched_event?.createdAt)).calendar()}
                                </p>
                            ) : (
                                <p className='empty-text'>...</p>
                            )}
                        </div>

                        <div className='details-content-item'>
                            <span className='title'>Last updated on</span>
                            {fetched_event?.updatedAt?.length > 0 ? (
                                <p className='text'>
                                    {moment(new Date(fetched_event?.updatedAt)).calendar()}
                                </p>
                            ) : (
                                <p className='empty-text'>...</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
